export default __webpack_public_path__ + "static/media/intelligent-quality.54fd2763.svg";